
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap')

// Require Vue
window.Vue = require('vue').default

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.component('clients-index', require('./components/Clients/Index').default)
Vue.component('clients-create', require('./components/Clients/Create').default)
Vue.component('clients-edit', require('./components/Clients/Edit').default)
Vue.component('users-index', require('./components/Users/Index').default)

import { ZiggyVue } from 'ziggy'
import { Ziggy } from './ziggy.js'
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-bootstrap.css'

Vue.use(VueToast)

if (process.env.NODE_ENV === 'production')
{
	Vue.use(ZiggyVue, Ziggy)
}

if (process.env.NODE_ENV === 'development') {
    Vue.mixin({
        methods: {
            route: route
        }
    })
}

// Initialize Vue
const app = new Vue({
    el: '#app',
})
